export default {
      id: "hep-b-usage",
      viewBox: "0 0 86 78.882",
      url: __webpack_public_path__ + "img/icons.8ad0c046.svg#hep-b",
      toString: function () {
        return this.url;
      }
    }